<!doctype html>
<div class="shadow-none ss-l-widget-fill" [ngClass]="{
    'custom-card-iframe': templateType === 'iframe',
    'custom-card-default': templateType !== 'iframe'
}">

    <div #classContainer class="ss-l-widget-fill">
        <ng-template #titleBlock>
            <ng-container *ngIf="showWidgetTitle" [ngSwitch]="widgetTitleTag">
                <h1 *ngSwitchCase="'h1'" class="ss-l-widget-title" [ngStyle]="{ 'text-align': titleAlignment, 'margin-bottom.px': titleSpacing }">{{ widgetTitle }}</h1>
                <h2 *ngSwitchCase="'h2'" class="ss-l-widget-title" [ngStyle]="{ 'text-align': titleAlignment, 'margin-bottom.px': titleSpacing }">{{ widgetTitle }}</h2>
                <h3 *ngSwitchCase="'h3'" class="ss-l-widget-title" [ngStyle]="{ 'text-align': titleAlignment, 'margin-bottom.px': titleSpacing }">{{ widgetTitle }}</h3>
                <h4 *ngSwitchCase="'h4'" class="ss-l-widget-title" [ngStyle]="{ 'text-align': titleAlignment, 'margin-bottom.px': titleSpacing }">{{ widgetTitle }}</h4>
                <h5 *ngSwitchCase="'h5'" class="ss-l-widget-title" [ngStyle]="{ 'text-align': titleAlignment, 'margin-bottom.px': titleSpacing }">{{ widgetTitle }}</h5>
                <h6 *ngSwitchDefault class="ss-l-widget-title" [ngStyle]="{ 'text-align': titleAlignment, 'margin-bottom.px': titleSpacing }">{{ widgetTitle }}</h6>
            </ng-container>
        </ng-template>

        <app-fake-page-preview [isAdmin]="isAdmin" *ngIf="templateType === 'discover'">
            <div class="ss-l-nuvemshop-wrapper" [ngStyle]="{
                'padding-top': paddingTopStyle, 'padding-right': paddingRightStyle,
                'padding-bottom': paddingBottomStyle, 'padding-left': paddingLeftStyle,
                'margin-top': marginTopStyle, 'margin-right': marginRightStyle,
                'margin-bottom': marginBottomStyle, 'margin-left': marginLeftStyle
            }">
                <ng-container *ngTemplateOutlet="titleBlock"></ng-container>
                <app-discover [ngClass]="{ 'ss-l-admin-mode': adminDeviceDisabled }" [templateType]="templateType" [widget_id]="widget_id"
                    [store_id]="store_id" [isAdmin]="isAdmin" [isCol4]="isCol4" [iconMode]="discoverIcon || 'cart'"
                    [showFilterBar]="discoverShowFilterBar ?? true" [arraySlicksFull]="arraySlicksFull"
                    [videoUrls]="videoUrls" [height]="height" [totalAssets]="totalAssets" [instanceId]="instanceId"
                    [discoverLayout]="discoverLayout" [showPostItemBadge]="discoverShowPostItemBadge" [hasMoreVideos]="hasMoreVideos"
                    [loading]="loading" (loadMoreVideos)="loadVideos()"
                    (filtersChange)="onDiscoverFiltersChange($event)"></app-discover>
            </div>
        </app-fake-page-preview>

        <ng-container *ngIf="templateType !== 'discover'" [ngSwitch]="templateType">
            <app-fake-page-preview [isAdmin]="isAdmin" *ngSwitchCase="'carousel'">
                <div class="ss-l-nuvemshop-wrapper" [ngStyle]="{
                    'padding-top': paddingTopStyle, 'padding-right': paddingRightStyle,
                    'padding-bottom': paddingBottomStyle, 'padding-left': paddingLeftStyle,
                    'margin-top': marginTopStyle, 'margin-right': marginRightStyle,
                    'margin-bottom': marginBottomStyle, 'margin-left': marginLeftStyle
                }">
                    <ng-container *ngTemplateOutlet="titleBlock"></ng-container>

                    <app-carousel [ngClass]="{ 'ss-l-admin-mode': adminDeviceDisabled }" [isCol4]="isCol4" [highlight]="highlight"
                        [templateType]="templateType" [widget_id]="widget_id" [store_id]="store_id" [position]="popupPosition || 'bottomright'"
                        [arraySlicksFull]="arraySlicksFull" [videoUrls]="videoUrls" [posterUrls]="posterUrls" [height]="height"
                        [pageToVideos]="pageToVideos" (loadMoreVideos)="loadMoreVideosForCarousel()"
                        [showProducts]="showProducts" (openSidebar)="onOpenSidebar()" [loadingComplete]="loadingComplete"
                        [containerDiv]="containerDiv" [isAdmin]="isAdmin" [totalAssets]="totalAssets"
                        [backgroundColor]="bg_color" [font_color]="font_color" [showDescription]="showDescription"
                        [instanceId]="instanceId">
                    </app-carousel>
                </div>
            </app-fake-page-preview>
            <app-fake-page-preview [isAdmin]="isAdmin" *ngSwitchCase="'stories'">
                <div class="ss-l-nuvemshop-wrapper" [ngStyle]="{
                    'padding-top': paddingTopStyle, 'padding-right': paddingRightStyle,
                    'padding-bottom': paddingBottomStyle, 'padding-left': paddingLeftStyle,
                    'margin-top': marginTopStyle, 'margin-right': marginRightStyle,
                    'margin-bottom': marginBottomStyle, 'margin-left': marginLeftStyle
                }">
                    <ng-container *ngTemplateOutlet="titleBlock"></ng-container>

                    <app-stories [ngClass]="{ 'ss-l-admin-mode': adminDeviceDisabled }" [templateType]="templateType" [widget_id]="widget_id" [store_id]="store_id"
                        [isAdmin]="isAdmin" [arraySlicksFull]="arraySlicksFull" [videoUrls]="videoUrls"
                        [posterUrls]="posterUrls" [height]="height" [pageToVideos]="pageToVideos"
                        (loadMoreVideos)="loadMoreVideosForCarousel()" (openSidebar)="onOpenSidebar()"
                        [loadingComplete]="loadingComplete" [containerDiv]="containerDiv" [totalAssets]="totalAssets"
                        [instanceId]="instanceId">
                    </app-stories>
                </div>
            </app-fake-page-preview>
            <app-grid *ngSwitchCase="'grid'" [ngClass]="{ 'ss-l-admin-mode': adminDeviceDisabled }" (loadMoreVideos)="loadVideos()" [templateType]="templateType" [widget_id]="widget_id" [store_id]="store_id"
                [height]="height" [isAdmin]="isAdmin" [videoUrls]="videoUrls" [isCol4]="isCol4"
                [arraySlicksFull]="arraySlicksFull" [totalAssets]="totalAssets"
                (loadMoreVideos)="loadMoreVideosForGrid()" [hasMoreVideos]="hasMoreVideos" [pageToVideos]="pageToVideos"
                (openSidebar)="onOpenSidebar()" [instanceId]="instanceId"></app-grid>
            <app-popup *ngSwitchCase="'popup'" [templateType]="templateType" [position]="popupPosition || 'bottomright'" [store_id]="store_id"
                [disableClicks]="disableClicks" [adminModeActive]="adminDeviceDisabled" [font_color]="font_color" [arraySlicksFull]="arraySlicksFull"
                [totalAssets]="totalAssets" [highlight]="highlight" (openSidebar)="onOpenSidebar()"
                [shape]="selectedShape" [isAdmin]="isAdmin" [backgroundColor]="bg_color" [pageToVideos]="pageToVideos"
                [videoUrls]="videoUrls" [height]="height" [widget_id]="widget_id" [instanceId]="instanceId">
            </app-popup>
            <app-fake-page-preview [isAdmin]="isAdmin" *ngSwitchCase="'inline'">
                <div class="ss-l-nuvemshop-wrapper" [ngStyle]="{
                    'padding-top': paddingTopStyle, 'padding-right': paddingRightStyle,
                    'padding-bottom': paddingBottomStyle, 'padding-left': paddingLeftStyle,
                    'margin-top': marginTopStyle, 'margin-right': marginRightStyle,
                    'margin-bottom': marginBottomStyle, 'margin-left': marginLeftStyle
                }">
                    <ng-container *ngTemplateOutlet="titleBlock"></ng-container>

                    <app-inline [ngClass]="{ 'ss-l-admin-mode': adminDeviceDisabled }" [height]="height" [templateType]="templateType" [showProducts]="showProducts"
                        [isAdmin]="isAdmin" [showDescription]="showDescription" [arraySlicksFull]="arraySlicksFull"
                        [aspectRatio]="aspectRatio" [videoUrls]="videoUrls" [isCol4]="isCol4"
                        [store_id]="store_id" [widget_id]="widget_id" (openSidebar)="onOpenSidebar()"
                        [instanceId]="instanceId"></app-inline>
                </div>
            </app-fake-page-preview>




            <!-- Enquanto selectedTemplate ainda é o placeholder inicial ('Criando Widget',
                 antes da API retornar o template real salvo), cai aqui — usa o mesmo
                 app-fake-page-preview dos outros templates (navbar/banner/grid) em vez do
                 skeleton antigo, pra não piscar um design diferente antes de resolver qual
                 template realmente carregar. -->
            <app-fake-page-preview [isAdmin]="isAdmin" *ngSwitchDefault></app-fake-page-preview>
        </ng-container>
    </div>
</div>
<app-video-modal [instanceId]="instanceId" [store_id]="store_id"></app-video-modal>
<p-toast></p-toast>